/*
* COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.

* This software is only to be used for the purpose for which it has been
* provided. No part of it is to be reproduced, disassembled, transmitted,
* stored in a retrieval system nor translated in any human or computer
* language in any way or for any other purposes whatsoever without the
* prior written consent of HSBC Holdings plc.

*/

import React from 'react';
import PropTypes from 'prop-types';
import { getContentByLocal } from '../../../../utils';
import CardList from '../CardList';

const AOFormList = (props) => {
    const { aoFormList, i18n, selectedLanguage, handelCardItem } = props;
    return (
        <div role="menu">
        {
            aoFormList && aoFormList.map((question, index) => {
                    const { questionLocales, questionStatus, questionId, questionIndicator } = question;
                    const questionStatusNumber = parseInt(questionStatus, 10)
                    return (
                        <CardList
                            content={{
                                title: {
                                    dataKey: `title-${questionIndicator}`,
                                    text: getContentByLocal(questionLocales, selectedLanguage)
                                },
                                statusTitle: {
                                    dataKey: `statusTitle-${questionIndicator}`,
                                    text: questionStatusNumber === 2 ? i18n.status.complete : i18n.status.incomplete
                                },
                                isComplete: questionStatusNumber === 2,
                                isIncomplete: questionStatusNumber === 1
                            }}
                            key={index}
                            questionId={questionId}
                            index={index}
                            handelCardItem={handelCardItem}
                        />
                    )
                })
            }
        </div>
    )
};


AOFormList.propTypes = {
    aoFormList: PropTypes.array.isRequired,
    i18n: PropTypes.object,
    selectedLanguage: PropTypes.string,
    handelCardItem: PropTypes.func,

};

export default AOFormList;



// WEBPACK FOOTER //
// ./src/views/AOFormReview/components/AOFormList/index.js